<div class="message-id-container">
  <span matTooltipClass="no-ellipsis" data-type="job-email-id"
        [matTooltip]="emailId">
  {{emailId}}
</span>
</div>

